'use strict';

var _ = require('lodash');
var SeasonalityReviewMonthCalendarController = function SeasonalityReviewMonthCalendarController($scope, $filter, momentService) {
  var DEFAULT_COLOR = '#CCC';
  var rmMomentFormat = $filter('rmMomentFormat');
  function init() {
    var date = momentService.of($scope.date, momentService.FIELD.DEPARTURE_DATE, 'YYYY-M');
    var curMon = date.month();
    var start = date.startOf('month');
    var done = false;
    $scope.legend = rmMomentFormat(start, 'FULL_MONTH_YEAR_SPACE_SEPARATED');
    $scope.weeks = [];
    while (!done) {
      var week = [];
      week[6] = undefined;
      while (!done) {
        week[start.weekday()] = {
          number: start.date(),
          date: rmMomentFormat(start, 'DATE_ISO'),
          color: DEFAULT_COLOR
        };
        start = start.add(1, 'day');
        done = start.month() !== curMon;
        if (start.weekday() === 0) {
          break;
        }
      }
      $scope.weeks.push(week);
    }
  }
  init();
  $scope.$watch('dateToColorMap', function (newValue) {
    if (!newValue) {
      return;
    }
    _.forEach($scope.weeks, function (week) {
      _.forEach(week, function (day) {
        if (!!day) {
          day.color = newValue[day.date] || day.color;
        }
      });
    });
  });
};
SeasonalityReviewMonthCalendarController.$inject = ['$scope', '$filter', 'MomentService'];
module.exports = SeasonalityReviewMonthCalendarController;